import create from "zustand"
import { persist } from "zustand/middleware"

export const useCart = create(
  persist(
    (set, get) => ({
      cart: [],
      addToCart: i =>
        set(({ cart }) => {
          const index = cart.findIndex(c => c.id === i.id)
          if (index >= Number(0)) {
            cart[index].quantity = cart[index].quantity + i.quantity
          } else {
            cart.push(i)
          }
        }),
      removeFromCart: i =>
        set(({ cart }) => {
          const index = cart.findIndex(c => c.id === i.id)
          cart.splice(index, index + 1)
        }),
      setItemQuantity: i =>
        set(({ cart }) => {
          const index = cart.findIndex(c => c.id === i.id)
          cart[index].quantity = i.quantity
        }),
      increment: i =>
        set(({ cart }) => {
          const index = cart.findIndex(c => c.id === i.id)
          cart[index].quantity++
        }),
      decrement: i =>
        set(({ cart }) => {
          const index = cart.findIndex(c => c.id === i.id)
          if (cart[index].quantity === 1) return
          cart[index].quantity--
        }),
      total: () => {
        const { cart } = get()
        return cart.reduce((acc, cur) => acc + cur.quantity * cur.price, 0)
      },
    }),
    {
      name: "shopping-cart",
    }
  )
)
